import { useFeatures } from '@/contexts/root-store-context'
import { useDocumentTitle } from '@/hooks/document-title'
import { observer } from 'mobx-react-lite'
import { useSearchParams } from 'react-router'
import { type AuthenticationViewModel } from '@/features/iam/auth/Authentication/AuthenticationViewModel'
import { Login, LoginView } from '@/features/iam/auth/components/Login'
import { ContentLoading } from '@/components/ContentLoading'
import { ErrorBlock } from '@/components/ErrorBlock'

export interface LoginContainerProps {
  vm: AuthenticationViewModel
}

export const LoginContainer = observer(function LoginContainer({
  vm,
}: LoginContainerProps) {
  const [searchParams] = useSearchParams()

  useDocumentTitle('Welcome')

  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))

  return (
    <LoginView>
      {vm.handleParams.match({
        pending: () => <ContentLoading />,
        rejected: (err) => <ErrorBlock error={err} />,
        resolved: () =>
          searchParams.get('show') ? (
            <ContentLoading />
          ) : (
            <Login
              logoPrimary={shellInfo.logoUrl}
              workspaceName={shellInfo.name}
              onLogin={vm.login}
              onSignUp={vm.signUp}
            />
          ),
      })}
    </LoginView>
  )
})
